import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

// Use environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// For testing purposes, if env variables are not set, provide defaults
const url = supabaseUrl || 'https://aoczwgqhfvncjzjnxkia.supabase.co';
const key = supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFvY3p3Z3FoZnZuY2p6am54a2lhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIwNTg4MTQsImV4cCI6MjA1NzYzNDgxNH0.CF2tWxS49KsC74R3P9v1YOAnUIW4ECllEepSNqZfdJk';

export const supabase = createClient<Database>(url, key);

export type Tables = Database['public']['Tables'];
export type Enums = Database['public']['Enums']; 